module.exports = __webpack_public_path__ + "fonts/Roboto-Black.cf56c1b.ttf";